<template>
  <div class="Blocks">
    <div class="Block_Top notranslate">
      <span class="notranslate"
        >Transactions<b class="notranslate">{{ Tiaoshu }}</b></span
      >
    </div>
    <div v-show="list1.length > 0">
      <div class="Block_list">
        <ul class="block_list_Top">
          <li>Hash</li>
          <!-- <li>Block</li> -->
          <li class="xila">Type</li>
          <li>Age</li>
          <li>From</li>
          <li>To</li>
          <li>Amount</li>
          <!-- <li>Gas</li> -->
        </ul>
      </div>
      <div class="Block_List_center notranslate">
        <ul>
          <li v-for="(item, index) in list1" :key="index">
            <p>
              <span @click="TxHash(index)">{{ item.txHash1 }}</span>
            </p>

            <p>{{ item.functions }}</p>
            <p>
              {{ item.tradeTime }}
              <!-- <span class="Hover1">
                  <span class="Hover"
                    >{{ TimeDate[index] }}<i class="iconfont">&#xe600;</i></span
                  >
                </span> -->
            </p>
            <p @click="Address(item.fromEvmAddress)">
              <span>
                {{ item.fromEvmAddress1 }}
              </span>
              <!-- <span class="yanca" v-if="item.type == 'Bonus'">Bonus</span>
              <span v-if="item.type == 'Unstake'" class="yanca">Unstake</span> -->
            </p>
            <p
              @click="Address(item.toEvmAddress)"
              v-if="item.toEvmAddress !== ''"
            >
              <span>{{ item.toEvmAddress1 }}</span>
            </p>
            <p style="color: #8d8d8d; cursor: default" v-else>
              <span>...</span>
            </p>

            <p style="cursor: pointer" @click="takengo(index)">
              {{ item.tokenAmount }} <img :src="item.logo" />
              <span>{{ item.symbol }}</span>
            </p>
          </li>
        </ul>
      </div>
      <div :class="list1.length > 10 ? 'Block_List_Bottom' : ''">
        <el-pagination
          ref="Pagination"
          :current-page.sync="PaginationIndex"
          background
          :page-size="20"
          layout="prev, pager,
      next"
          @current-change="CurrentChange"
          :total="total1"
        >
        </el-pagination>
      </div>
    </div>
    <div v-show="list1.length <= 0">
      <EmptyState />
    </div>
  </div>
</template>

<script>
import Listbox from "../../../components/pc/Listbox.vue";
import Pagination from "../BlockList/Pagination";
import Pagination2 from "../BlockList/Pagination2.vue";
import EmptyState from "../EmptyState/EmptyState.vue";
import { TradeList, ContractTxList } from "@/assets/server/api";
import {
  timestampConvertTime,
  formatSeconds,
  getSubStr,
  listTypea,
  countDecimalPlaces,
  formattedNumber
} from "@/utils/utils";
// import { TypeTxsList } from "@/assets/server/api.js";
// const echarts = require("echarts");
export default {
  props: ["List", "tradeNums"],
  data() {
    return {
      list1: [],
      Time: [],
      PaginationIndex: 1,
      total1: null,
      Type: "",
      txHash: [],
      fromAddress: [],
      toAddress: [],
      data: [],
      data2: [],
      data3: [],
      ToList: 0,
      Tiaoshu: "",
      Page1: "",
      TimeDate: [],
      ImgUrl4: require("@/assets/pc/TopValidators/xiala2.png"), //向下下拉箭头
      imgurl: require("@/assets/pc/Index/indexlogo.png"),
      value: "",
    };
  },
  components: {
    Pagination,
    Pagination2,
    EmptyState,
    Listbox,
  },
  computed: {
    getClientTimezone() {
      var oDate = new Date();
      var nTimezone = -oDate.getTimezoneOffset() / 60;
      return nTimezone.toFixed(2);
    },
  },
  watch: {},
  created() {
    this.PaginationIndex = 1;
    // this.TransactionsList();
  },
  mounted() {
    // this.initCharts();
    this.getContractTxList();
  },
  methods: {
    async getContractTxList() {
      let formData = new FormData();
      let params = {
        standard: "ERC-20",
        pageNum: this.PaginationIndex,
        pageSize: 20,
      };
      let item = params;

      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      var res = await ContractTxList(formData);
      //  console.log(res);
      var calctime = new Date();
      //let strdate = Math.floor(calctimea.getTime() / 1000);
      let strdate = Math.floor(calctime.getTime() / 1000);
      this.list1 = res.result.list;
      //  console.log(this.list1);
      this.total1 = res.result.count;
      for (var i = 0; i < this.list1.length; i++) {
        if (this.list1[i].logo == "") {
          this.list1[i].logo = this.imgurl;
        }
        if (this.list1[i].tokenAmount.length > 8) {
          this.list1[i].tokenAmount =
          formattedNumber(this.list1[i].tokenAmount.slice(0, 8)) +
            "...";
        } else {
          this.list1[i].tokenAmount = formattedNumber(this.list1[i].tokenAmount);
        }
        if (this.list1[i].symbol.trim() == "") {
          if (this.list1[i].contractName.trim() !== "") {
            this.list1[i].symbol = this.list1[i].contractName;
          } else {
            this.list1[i].symbol = getSubStr(
              this.list1[i].contractAddress,
              0,
              3
            );
          }
        } else {
          this.list1[i].symbol = this.list1[i].symbol;
        }
        // if((this.list1[i].tokenAmount).toString().split(".")[1].length >8){
        // this.list1[i].tokenAmount=  this.list1[i].tokenAmount.substring(0, this.list1[i].tokenAmount.indexOf('.') + 9) * 1
        //  if(countDecimalPlaces(this.list1[i].tokenAmount)>8){
        //   this.list1[i].tokenAmount=   Number((this.list1[i].tokenAmount).toString().match(/^\d+(?:\.\d{0,8})?/));
        //  }
        //  }

        // this.list1[i].tokenAmount=  Math.floor( this.list1[i].tokenAmount * 100)/100;
        //this.list1[i].tokenAmount= (Math.floor(this.list1[i].tokenAmount* 10000000) / 10000000)
        // if(parseInt(this.list1[i].tokenAmount*10000000)==0){
        //   this.list1[i].tokenAmount=0;
        // }else{
        //   this.list1[i].tokenAmount=(parseInt(this.list1[i].tokenAmount*10000000))/10000000;
        //}
        this.list1[i].txHash1 = getSubStr(this.list1[i].txHash, 0, 6);
        this.list1[i].toEvmAddress1 = getSubStr(
          this.list1[i].toEvmAddress,
          0,
          6
        );
        this.list1[i].fromEvmAddress1 = getSubStr(
          this.list1[i].fromEvmAddress,
          0,
          6
        );
        // this.list1=getSubStr(this.list1[i].txHash,0,6);
        let timestamp = Math.floor(this.gltime(this.list1[i].tradeTime) / 1000);
        var s = strdate - timestamp;
        if (s <= 0) {
          s = 1;
        }
        this.list1[i].tradeTime = formatSeconds(s);
        //this.list1[i].type = listTypea(this.list1[i].type);
      }
    },

    async getTypeTxsList() {
      let formData = new FormData();
      let params = {
        address: this.$route.query.Address,
        type: this.value,
        pageNum: this.PaginationIndex,
        pageSize: 10,
      };
      let item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      var res = await TypeTxsList(formData);
      //  console.log(res);
    },
    CurrentChange(val) {
      this.PaginationIndex = val;
      // this.setContextData("tiaozhuan2", this.PaginationIndex);
      //this.TransactionsList();
      this.getContractTxList();
    },
    TransactionsList() {
      let _this = this;
      const params = {
        pageNum: _this.PaginationIndex,
        pageSize: 10,
      };
      const formData = new FormData();
      const item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      TradeList(formData).then((res) => {
        _this.list = res.result.tradeList;
        this.Tiaoshu = res.result.total;
        this.Tiaoshu = "(" + this.Tiaoshu + ")";
        _this.total1 = res.result.total;
        var calctime = new Date();
        let strdate = Math.floor(calctime.getTime() / 1000);
        for (let i = 0; i < _this.list.length; i++) {
          let UTCTime =
            res.result.tradeList[i].tradeTime -
            this.getClientTimezone * 3600000;
          this.TimeDate[i] = timestampConvertTime(UTCTime);
          let timestamp = Math.floor(
            this.gltime(this.list[i].tradeTime) / 1000
          );
          var s = strdate - timestamp;
          if (s <= 0) {
            s = 1;
          }
          this.list[i].tradeTime = formatSeconds(s);
          this.list[i].toAddress = _this.list[i].toAddress.split(",");

          if (_this.list[i].type == 1) {
            _this.list[i].type = "Transfer";
          } else if (_this.list[i].type == 2) {
            _this.list[i].type = "Stake";
          } else if (_this.list[i].type == 3) {
            _this.list[i].type = "Unstake";
          } else if (_this.list[i].type == 5) {
            _this.list[i].type = "Withdraw";
          } else if (_this.list[i].type == 4) {
            _this.list[i].type = "Delegate";
          } else if (_this.list[i].type == 99) {
            _this.list[i].type = "Bonus";
          } else if (_this.list[i].type == -1) {
            _this.list[i].type = "Genesis";
          }
        }
      });
    },
    gltime(i) {
      const toDate = new Date(i);
      var d = toDate;
      var localTime = d.getTime();
      var localOffset = d.getTimezoneOffset() * 60000;
      var utc = localTime + localOffset;
      var offset = this.getClientTimezone;
      var korean = utc + 3600000 * offset;
      var nd = korean;
      return nd;
    },
    takengo(index) {
      let params = {
        contractAddress: this.list1[index].contractAddress,
      };
      this.$router.push({ path: "/pc/Overview", query: params });
    },
    TxHash(index) {
      let params = {
        txHash: this.list1[index].txHash,
        type: 8,
        standard: this.list1[index].standard,
      };
      this.$router.push({ path: "/pc/To", query: params });
    },

    Address(index) {
      // let params = this.list[index].fromAddress;
      this.$router.push({ path: "/pc/BkHash", query: { query: index } });
    },
    Address2(index) {
      let params = this.list[index].toAddress[0];
      this.$router.push({ path: "/pc/BkHash", query: { query: params } });
    },
    tiaozhuan1(e) {
      this.PaginationIndex = e;
      //this.TransactionsList();
    },
    setContextData: function (key, value) {
      if (typeof value == "string") {
        sessionStorage.setItem(key, value);
      } else {
        sessionStorage.setItem(key, JSON.stringify(value));
      }
    },
    getContextData: function (key) {
      const str = sessionStorage.getItem(key);
      if (typeof str == "string") {
        try {
          return JSON.parse(str);
        } catch (e) {
          return str;
        }
      }
      return;
    },
  },
};
</script>

<style lang="less" scoped>
.Blocks {
  // padding: 20px 20px;
  width: 1160px;
  // height: 1480px;
  // margin: 0 auto;
  // border: 1px solid red;
  background: #000000;
  border-radius: 16px 16px 16px 16px;
  .Block_Top {
    padding-top: 30px;
    width: 100%;
    margin: 0 auto;
    padding-bottom: 30px;
    margin-left: 20px;
    display: flex;
    span {
      flex: 1;
    }
    span:nth-child(1) {
      font-size: 18px;
      font-family: Source Han Sans CN-Medium, Source Han Sans CN;
      font-weight: 500;
      color: #ffffff;
      line-height: 24px;
      -webkit-background-clip: text;
      b {
        margin-left: 4px;
        font-size: 18px;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #ffffff;
      }
    }
  }
  .Block_list {
    width: 1120px;
    margin: 0 auto;
    // border: 1px solid green;
    .block_list_Top {
      display: flex;
      width: 1120px;
      height: 60px;
      background: #14151a;
      border-radius: 10px 10px 10px 10px;
      opacity: 1;
      li {
        font-size: 16px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #898b8d;
        height: 60px;
        line-height: 60px;
        -webkit-background-clip: text;
        flex: 0 0 14.6%;
        // border: 1px solid green;
        text-align: left;
        margin-left: 20px;
      }
      .xila {
        position: relative;
      }
      li:nth-child(3) {
        flex: 0 0 16.8%;
        // border: 1px solid yellow;
      }
    }
  }
  .Block_List_center {
    width: 1120px;
    margin: 0 auto;
    ul {
      height: 660px;
      width: 1120px;
      // border: 1px solid yellow;
      // padding: 0 19px;
      li:last-child {
        //  border-bottom: none;
      }
      li {
        display: flex;
        height: 62px;
        border-bottom: 1px solid #22252e;
        line-height: 62px;
        p {
          font-size: 14px;
          font-family: SF Pro Text-Regular, SF Pro Text;
          font-weight: 400;
          -webkit-background-clip: text;
          flex: 0 0 14.6%;
          // border: 1px solid red;
          text-align: left;
          margin-left: 20px;
          span {
            display: inline-block;
            width: 150px;
          }
          img {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            margin: 18px 6px 0px 6px;
          }
        }
      }
      li:nth-child(10) {
        //border-bottom: none !important;
      }
      p:nth-child(1) {
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #ffffff;
        // border: 1px solid red;
        cursor: pointer;
      }
      p:nth-child(1):hover,
      p:nth-child(4):hover,
      p:nth-child(5):hover {
        color: #00e79a;
      }
      p:nth-child(2) {
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #898b8d;
      }

      p:nth-child(3) {
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #898b8d;
        flex: 0 0 16.8%;
        position: relative;
        cursor: default;
        .Hover1 {
          display: none;
          .Hover {
            width: 196px !important;
            padding: 3px 10px;
            display: inline-block;
            line-height: 20px;
            position: absolute;
            top: -10px;
            left: 0px;
            background-color: #3c485c;
            border-radius: 5px;
            i {
              position: absolute;
              top: 18px;
              left: 40%;
              transform: rotate(180deg);
              color: #3c485c;
            }
          }
        }
      }
      p:nth-child(4) {
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #ffffff;
        cursor: pointer;
      }
      p:nth-child(5) {
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #ffffff;
        cursor: pointer;
      }
      .active {
        color: #fff !important;
        cursor: pointer;
      }
      .active:hover {
        color: #00e79a !important;
      }
      p:nth-child(6) {
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        // color: red;
        color: #fff;
        display: flex;
      }
      p:nth-child(7) {
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #898b8d;
      }
    }
  }
  .Block_List_Bottom {
    margin-top: 616px;
    padding-bottom: 30px;
  }
}
.yanca {
  color: #898b8d !important;
  cursor: text;
}
@font-face {
  font-family: "aaa";
  src: url("../../../assets/font/NotoSans-Regular.ttf");
}
.el-pagination {
  display: flex;
  justify-content: right;
  ::v-deep button {
    min-width: 24px !important;
    height: 24px !important;
    font-size: 12px;
    color: #fff !important;
    background: none !important;
    // background: #3c485c !important;
    border-radius: 4px 4px 4px 4px !important;
  }
  ::v-deep ul {
    li {
      min-width: 24px !important;
      height: 24px !important;
      background: none !important;
      //border-radius: 4px 4px 4px 4px !important;
      font-size: 12px;
      font-family: aaa;
      font-weight: 400 !important;
      color: #ffffff !important;
      line-height: 20px !important;
      margin: 0 4px !important;
      padding: 2px 8px !important;
    }
    .active {
      background: #22252e !important;
    }
    .more::before {
      line-height: 20px !important;
    }
  }
}
</style>
